import React from 'react';
import styled from 'styled-components';
import { getClientsTaskFactory } from '~admin/interactor/client/perform-get-clients';
import { ClientProfileData } from '~admin/model/client-profile-data';
import { AddClientOverlay } from '~admin/view/components/details/client-details/add-client-overlay.component';
import { ClientNameDropdown } from '~admin/view/components/details/client-details/client-dropdowns/client-name-dropdown.component';
import { AddButton } from '~admin/view/components/ui/button/add-button.component';
import { Box } from '~common/components/box.component';
import { useModalControls } from '~common/hook/use-modal-controls';
import { useTask } from '~common/hook/use-task';

interface Props {
  onClientCreated?: (client: ClientProfileData) => void;
  disabled?: boolean;
}

export const ClientDetails: React.FunctionComponent<Props> = ({
  onClientCreated,
  disabled,
  ...rest
}) => {
  const [overlayShown, showOverlay, hideOverlay] = useModalControls();
  const getClientsTask = useTask(getClientsTaskFactory);

  return (
    <Container {...rest}>
      <ClientNameDropdown task={getClientsTask} disabled={disabled} />
      <StyledAddButton onClick={showOverlay} disabled={disabled} />
      {overlayShown && (
        <AddClientOverlay
          onCancel={hideOverlay}
          onClientCreated={(client: ClientProfileData): void => {
            getClientsTask();
            onClientCreated(client);
            hideOverlay();
          }}
        />
      )}
    </Container>
  );
};
const Container = styled(Box)`
  flex: 1 1 auto;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 18px;
`;

const StyledAddButton = styled(AddButton)`
  && {
    margin-left: 16px;
  }
`;



// WEBPACK FOOTER //
// ./view/components/details/client-details/client-details.component.tsx